import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, withStyles } from '@material-ui/core'
import { Label } from '../../default'
import { CardSearchFilter } from '../../cards'
import TableFilterList from './TableFilterList'

const PanelFilterList = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>

      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.filters.title')}</Label>
      </Grid>

      <Grid item xs={12}>
        <CardSearchFilter />
      </Grid>

      <Grid item xs={12}>
        <TableFilterList />
      </Grid>

    </Grid>
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelFilterList)